import type { CSSProperties, ImgHTMLAttributes } from 'react';
import { brandAssets } from '../assets/brand';

export type AvatarIconVariant = 'white' | 'orange';

export interface AvatarIconProps extends Omit<ImgHTMLAttributes<HTMLImageElement>, 'src' | 'alt'> {
  /** `white` = web chat panel; `orange` = mobile / light surfaces */
  variant?: AvatarIconVariant;
  size?: number;
  alt?: string;
  style?: CSSProperties;
}

const SRC: Record<AvatarIconVariant, string> = {
  white: brandAssets.iconWhite,
  orange: brandAssets.iconOrange,
};

/** Brand robot mark — uses SVGs from `assets/brand`. */
export default function AvatarIcon({
  variant = 'orange',
  size = 28,
  alt = '',
  style,
  ...rest
}: AvatarIconProps) {
  return (
    <img
      src={SRC[variant]}
      alt={alt}
      width={size}
      height={size}
      draggable={false}
      style={{ width: size, height: size, objectFit: 'contain', display: 'block', ...style }}
      {...rest}
    />
  );
}
